/**
 * Отметка обязательного поля. Подпись поля — flex-строка с промежутком между словом и отметкой,
 * поэтому там звёздочку подтягиваем обратно к слову; в заголовке набора полей промежутка нет и
 * подтягивать нечего.
 */
export const RequiredMark = () => (
  <span className="text-destructive [[data-slot=field-label]>&]:-ms-1" title="Обязательное поле">
    <span aria-hidden="true">*</span>
    <span className="sr-only">обязательное поле</span>
  </span>
)
